module.exports = __webpack_public_path__ + "static/media/delete.4811225c.svg";